import { render, staticRenderFns } from "./LayoutAside.vue?vue&type=template&id=50d553a4&scoped=true&"
import script from "./LayoutAside.vue?vue&type=script&lang=js&"
export * from "./LayoutAside.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAside.vue?vue&type=style&index=0&id=50d553a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d553a4",
  null
  
)

export default component.exports